import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

import { preferencesSuccess } from "../User/redux/user.actions"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  inviteByEmailRequest: ["payload"], // payload: { data }
  inviteByEmailSuccess: ["payload"], // payload: { data }
  inviteByEmailFailure: ["payload"], // payload: { errors }

  getYourCommissionsRequest: ["payload"], // payload: { data }
  getYourCommissionsSuccess: ["payload"], // payload: { data }
  getYourCommissionsFailure: ["payload"], // payload: { errors }

  getInviteLinkRequest: ["payload"], // payload: { data }
  getInviteLinkSuccess: ["payload"], // payload: { data }
  getInviteLinkFailure: ["payload"], // payload: { errors }

  getReferralsTableRequest: ["payload"], // payload: { data }
  getReferralsTableSuccess: ["payload"], // payload: { data }
  getReferralsTableFailure: ["payload"], // payload: { errors }

  getAlertsByBusinessAccountIdRequest: ["payload"], // payload: { data }
  getAlertsByBusinessAccountIdSuccess: ["payload"], // payload: { data }
  getAlertsByBusinessAccountIdFailure: ["payload"], // payload: { errors }

  getFaqRequest: ["payload"], // payload: { data }
  getFaqSuccess: ["payload"], // payload: { data }
  getFaqFailure: ["payload"], // payload: { errors }

  getTotalStatisticsRequest: ["payload"], // payload: { data }
  getTotalStatisticsSuccess: ["payload"], // payload: { data }
  getTotalStatisticsFailure: ["payload"], // payload: { errors }

  getReferralsOverviewDataRequest: ["payload"], // payload: { data }
  getReferralsOverviewDataSuccess: ["payload"], // payload: { data }
  getReferralsOverviewDataFailure: ["payload"], // payload: { errors }

  getReferralsOverviewMainInfoRequest: ["payload"], // payload: { data }
  getReferralsOverviewMainInfoSuccess: ["payload"], // payload: { data }
  getReferralsOverviewMainInfoFailure: ["payload"], // payload: { errors }

  getReferralBAOptionsRequest: ["payload"], // payload: { data }
  getReferralBAOptionsSuccess: ["payload"], // payload: { data }
  getReferralBAOptionsFailure: ["payload"], // payload: { errors }

  getAlertsBySourceTableRequest: ["payload"], // payload: { data }
  getAlertsBySourceTableSuccess: ["payload"], // payload: { data }
  getAlertsBySourceTableFailure: ["payload"], // payload: { errors }

  getAdminStatisticBlocksRequest: ["payload"], // payload: { data }
  getAdminStatisticBlocksSuccess: ["payload"], // payload: { data }
  getAdminStatisticBlocksFailure: ["payload"], // payload: { errors }

  getAdminStatisticBlockChartRequest: ["payload"], // payload: { data }
  getAdminStatisticBlockChartSuccess: ["payload"], // payload: { data }
  getAdminStatisticBlockChartFailure: ["payload"], // payload: { errors }

  getAdminTableRequest: ["payload"], // payload: { data }
  getAdminTableSuccess: ["payload"], // payload: { data }
  getAdminTableFailure: ["payload"], // payload: { errors }

  exportAdminTableRequest: ["payload"], // payload: { data }
  exportAdminTableSuccess: ["payload"], // payload: { data }
  exportAdminTableFailure: ["payload"], // payload: { errors }
  resetAdminTableExportData: null,

  getAdminTableAlertsChartRequest: ["payload"], // payload: { data }
  getAdminTableAlertsChartSuccess: ["payload"], // payload: { data }
  getAdminTableAlertsChartFailure: ["payload"], // payload: { errors }

  getAdminTableRewardChartRequest: ["payload"], // payload: { data }
  getAdminTableRewardChartSuccess: ["payload"], // payload: { data }
  getAdminTableRewardChartFailure: ["payload"], // payload: { errors }

  outsiderWithdrawRequest: ["payload"], // payload: { data }
  outsiderWithdrawSuccess: ["payload"], // payload: { data }
  outsiderWithdrawFailure: ["payload"], // payload: { errors }

  getOutsiderBlocksRequest: ["payload"], // payload: { data }
  getOutsiderBlocksSuccess: ["payload"], // payload: { data }
  getOutsiderBlocksFailure: ["payload"], // payload: { errors }

  getOutsiderPayoutMethodRequest: ["payload"],
  getOutsiderPayoutMethodSuccess: ["payload"],
  getOutsiderPayoutMethodFailure: ["payload"],

  addOutsiderPayoutMethodRequest: ["payload"],
  addOutsiderPayoutMethodSuccess: ["payload"],
  addOutsiderPayoutMethodFailure: ["payload"],

  updateOutsiderPayoutMethodRequest: ["payload"],
  updateOutsiderPayoutMethodSuccess: ["payload"],
  updateOutsiderPayoutMethodFailure: ["payload"],

  getOutsiderWithdrawalsHistoryRequest: ["payload"],
  getOutsiderWithdrawalsHistorySuccess: ["payload"],
  getOutsiderWithdrawalsHistoryFailure: ["payload"],

  getReferralBusinessAccountInfoRequest: ["payload"], // payload: { data }
  getReferralBusinessAccountInfoSuccess: ["payload"], // payload: { data }
  getReferralBusinessAccountInfoFailure: ["payload"], // payload: { errors }

  getAffiliateAccountInfoRequest: ["payload"], // payload: { data }
  getAffiliateAccountInfoSuccess: ["payload"], // payload: { data }
  getAffiliateAccountInfoFailure: ["payload"], // payload: { errors }

  getCountryCodesRequest: null,
  getCountryCodesSuccess: ["payload"],
  getCountryCodesFailure: ["payload"],

  setEarningsFilters: ["filters"],
  setAdminTableFilters: ["payload"], // payload: { filters, visibleFilters }
  setAdminTableColumns: ["payload"], // payload: { columns }
  clearAdminTableFilters: null,

  resetMessage: null,
  logout: null
})

export const ReferralTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const adminTableDefaultColumns = [
  { field_id: "affiliate_full_name", label: "Affiliate", active: true },
  { field_id: "affiliate_email", label: "Affiliate email", active: true },
  { field_id: "categories", label: "Type", active: true },
  { field_id: "referral_full_name", label: "Invited referral", active: true },
  { field_id: "referral_email", label: "Invited referral email", active: true },
  { field_id: "referral_status", label: "Referral status", active: true },
  { field_id: "business_account_created", label: "Date", active: true },
  { field_id: "business_account_name", label: "Referral BA", active: true },
  { field_id: "business_account_status", label: "BA status", active: true },
  { field_id: "reward", label: "Reward", active: true },
  { field_id: "alerts", label: "Alerts", active: true }
]

export const pinnedCols = ["affiliate_full_name"]
export const editableColumns = adminTableDefaultColumns.filter(
  (c) => !pinnedCols.includes(c.field_id)
)

const adminTableFilterOptions = {
  business_account_status: [
    "pending",
    "active",
    "needs_help",
    "incomplete",
    "unenrolled",
    "failed",
    "inactive"
  ],
  referral_status: ["Active", "Invited", "Setup Pending", "Verified", "Unverified", "Unenrolled"]
}

export const INITIAL_STATE = Immutable({
  inviteLink: '"https://app.chargeback.io/go-premium?promoCodeXXXXXXXXXXX"',
  earningsFilters: {
    period: "27 days",
    business_accounts: "all"
  },
  loading: false,
  baAlertsFetching: false,
  message: null,
  referralsTable: [],
  referralsTableFetching: false,
  baAlerts: null,
  commissions: [],
  faq: [],
  totalStatistics: null,
  totalStatisticsFetching: false,
  overviewData: null,
  overviewDataFetching: false,
  overviewMainInfo: null,
  overviewMainInfoFetching: false,
  referralBAOptions: [],
  alertsBySourceTable: null,
  alertsBySourceFetching: false,
  adminTable: null,
  adminTableFetching: false,
  adminTableExportData: null,
  adminTableExportFetching: false,
  adminTableFilters: {
    affiliate_full_name: [],
    affiliate_email: [],
    referral_full_name: [],
    referral_email: [],
    referral_status: "all",
    business_account_created: null,
    business_account_name: [],
    business_account_status: "all"
  },
  adminTableVisibleFilters: {
    affiliate_full_name: true,
    affiliate_email: true
  },
  adminTableFilterOptions: adminTableFilterOptions,
  adminTableColumns: [...editableColumns],
  adminTableAlertsChart: null,
  adminTableAlertsChartFetching: false,
  adminTableRewardChart: null,
  adminTableRewardChartFetching: false,

  outsiderBlocks: null,
  outsiderBlocksFetching: false,
  outsiderWithdraw: null,
  outsiderWithdrawFetching: false,
  outsiderPayoutMethod: null,
  outsiderPayoutMethodFetching: false,
  addOutsiderPayoutMethodFetching: false,
  updateOutsiderPayoutMethodFetching: false,
  outsiderWithdrawalsHistory: [],
  outsiderWithdrawalsHistoryFetching: false,
  referralBusinessAccount: null,
  referralBusinessAccountFetching: false,
  countryCodes: null,
  countryCodesFetching: false,
  affiliateAccountInfo: null,
  affiliateAccountInfoFetching: false
})

/* ------------- Functions for reducer cases ------------- */
const inviteByEmailRequest = (state) => state.merge({ loading: true })
const inviteByEmailSuccess = (state, { payload }) =>
  state.merge({
    loading: false,
    message: payload.message
  })

const inviteByEmailFailure = (state) => state.merge({ loading: false })

const getReferralsTableRequest = (state) => state.merge({ referralsTableFetching: true })
const getReferralsTableSuccess = (state, { payload }) =>
  state.merge({
    referralsTableFetching: false,
    referralsTable: payload
  })

const getReferralsTableFailure = (state) => state.merge({ referralsTableFetching: false })
const getAlertsByBusinessAccountIdRequest = (state) => state.merge({ baAlertsFetching: true })
const getAlertsByBusinessAccountIdSuccess = (state, { payload }) =>
  state.merge({
    baAlertsFetching: false,
    baAlerts: payload
  })
const getAlertsByBusinessAccountIdFailure = (state) => state.merge({ baAlertsFetching: false })

const getYourCommissionsRequest = (state) => state.merge({ loading: true })
const getYourCommissionsSuccess = (state, { payload }) =>
  state.merge({
    loading: false,
    commissions: payload
  })

const getYourCommissionsFailure = (state) => state.merge({ loading: false })
const getInviteLinkRequest = (state) => state.merge({ loading: true })
const getInviteLinkSuccess = (state, { payload }) =>
  state.merge({
    loading: false,
    inviteLink: payload.link
  })

const getInviteLinkFailure = (state) => state.merge({ loading: false })

const getFaqRequest = (state) => state.merge({ loading: true })
const getFaqSuccess = (state, { payload }) =>
  state.merge({
    loading: false,
    faq: payload
  })
const getFaqFailure = (state) => state.merge({ loading: false })

const getTotalStatisticsRequest = (state) => state.merge({ totalStatisticsFetching: true })
const getTotalStatisticsSuccess = (state, { payload }) =>
  state.merge({
    totalStatisticsFetching: false,
    totalStatistics: payload
  })
const getTotalStatisticsFailure = (state) => state.merge({ totalStatisticsFetching: false })

const getReferralsOverviewDataRequest = (state) => state.merge({ overviewDataFetching: true })
const getReferralsOverviewDataSuccess = (state, { payload }) =>
  state.merge({
    overviewDataFetching: false,
    overviewData: payload
  })
const getReferralsOverviewDataFailure = (state, { errors }) =>
  state.merge({
    overviewDataFetching: false
  })

const getReferralsOverviewMainInfoRequest = (state) =>
  state.merge({ overviewMainInfoFetching: true })
const getReferralsOverviewMainInfoSuccess = (state, { payload }) =>
  state.merge({
    overviewMainInfoFetching: false,
    overviewMainInfo: payload
  })
const getReferralsOverviewMainInfoFailure = (state, { errors }) =>
  state.merge({
    overviewMainInfoFetching: false
  })

const getReferralBAOptionsRequest = (state) => state.merge()
const getReferralBAOptionsSuccess = (state, { payload }) =>
  state.merge({
    referralBAOptions: payload
  })
const getReferralBAOptionsFailure = (state, { errors }) => state.merge()

const getAlertsBySourceTableRequest = (state) => state.merge({ alertsBySourceFetching: true })
const getAlertsBySourceTableSuccess = (state, { payload }) =>
  state.merge({
    alertsBySourceFetching: false,
    alertsBySourceTable: payload
  })
const getAlertsBySourceTableFailure = (state, { errors }) =>
  state.merge({
    alertsBySourceFetching: false
  })

const getAdminStatisticBlocksRequest = (state) =>
  state.merge({ adminStatisticBlocksFetching: true })
const getAdminStatisticBlocksSuccess = (state, { payload }) =>
  state.merge({
    adminStatisticBlocksFetching: false,
    adminStatisticBlocks: payload
  })
const getAdminStatisticBlocksFailure = (state, { errors }) =>
  state.merge({
    adminStatisticBlocksFetching: false
  })

const getAdminStatisticBlockChartRequest = (state) =>
  state.merge({ adminStatisticBlockChartFetching: true })
const getAdminStatisticBlockChartSuccess = (state, { payload }) =>
  state.merge({
    adminStatisticBlockChartFetching: false,
    adminStatisticBlockChart: payload
  })
const getAdminStatisticBlockChartFailure = (state, { errors }) =>
  state.merge({
    adminStatisticBlockChartFetching: false
  })

const getAdminTableRequest = (state) => state.merge({ adminTableFetching: true })
const getAdminTableSuccess = (state, { payload }) => {
  return state.merge({
    adminTableFetching: false,
    adminTable: payload
  })
}
const getAdminTableFailure = (state, { errors }) =>
  state.merge({
    adminTableFetching: false
  })

const exportAdminTableRequest = (state) => state.merge({ adminTableExportFetching: true })
const exportAdminTableSuccess = (state, { payload }) => {
  return state.merge({
    adminTableExportFetching: false,
    adminTableExportData: payload
  })
}
const resetAdminTableExportData = (state) => state.merge({ adminTableExportData: null })
const exportAdminTableFailure = (state, { errors }) =>
  state.merge({
    adminTableExportFetching: false
  })

const getAdminTableAlertsChartRequest = (state) =>
  state.merge({ adminTableAlertsChartFetching: true })
const getAdminTableAlertsChartSuccess = (state, { payload }) => {
  return state.merge({
    adminTableAlertsChartFetching: false,
    adminTableAlertsChart: payload
  })
}
const getAdminTableAlertsChartFailure = (state, { errors }) =>
  state.merge({
    adminTableAlertsChartFetching: false
  })

const getAdminTableRewardChartRequest = (state) =>
  state.merge({ adminTableRewardChartFetching: true })
const getAdminTableRewardChartSuccess = (state, { payload }) => {
  return state.merge({
    adminTableRewardChartFetching: false,
    adminTableRewardChart: payload
  })
}
const getAdminTableRewardChartFailure = (state, { errors }) =>
  state.merge({
    adminTableRewardChartFetching: false
  })

const setEarningsFilters = (state, { filters }) =>
  state.merge({
    earningsFilters: { ...state.earningsFilters, ...filters }
  })

const setAdminTableFilters = (state, { payload }) =>
  state.merge({
    adminTableFilters: { ...state.adminTableFilters, ...payload?.filters },
    adminTableVisibleFilters: {
      ...state.adminTableVisibleFilters,
      ...payload?.visibleFilters
    }
  })

const setAdminTableColumns = (state, { payload }) =>
  state.merge({
    adminTableColumns: payload?.columns
  })

const clearAdminTableFilters = (state, {}) =>
  state.merge({
    adminTableFilters: INITIAL_STATE.adminTableFilters
  })

const getOutsiderBlocksRequest = (state) => state.merge({ outsiderBlocksFetching: true })
const getOutsiderBlocksSuccess = (state, { payload }) =>
  state.merge({
    outsiderBlocksFetching: false,
    outsiderBlocks: payload
  })
const getOutsiderBlocksFailure = (state) => state.merge({ outsiderBlocksFetching: false })

const outsiderWithdrawRequest = (state) => state.merge({ outsiderWithdrawFetching: true })
const outsiderWithdrawSuccess = (state, { payload }) =>
  state.merge({
    outsiderWithdrawFetching: false,
    outsiderWithdraw: payload,
    message: payload?.message ?? state.message
  })
const outsiderWithdrawFailure = (state) => state.merge({ outsiderWithdrawFetching: false })

const getOutsiderPayoutMethodRequest = (state) =>
  state.merge({ outsiderPayoutMethodFetching: true })
const getOutsiderPayoutMethodSuccess = (state, { payload }) =>
  state.merge({
    outsiderPayoutMethodFetching: false,
    outsiderPayoutMethod: payload
  })
const getOutsiderPayoutMethodFailure = (state) =>
  state.merge({ outsiderPayoutMethodFetching: false })

const addOutsiderPayoutMethodRequest = (state) =>
  state.merge({ addOutsiderPayoutMethodFetching: true })
const addOutsiderPayoutMethodSuccess = (state, { payload }) =>
  state.merge({
    addOutsiderPayoutMethodFetching: false,
    outsiderPayoutMethod: payload,
    message: payload?.message ?? state.message
  })
const addOutsiderPayoutMethodFailure = (state) =>
  state.merge({ addOutsiderPayoutMethodFetching: false })

const updateOutsiderPayoutMethodRequest = (state) =>
  state.merge({ updateOutsiderPayoutMethodFetching: true })
const updateOutsiderPayoutMethodSuccess = (state, { payload }) =>
  state.merge({
    updateOutsiderPayoutMethodFetching: false,
    outsiderPayoutMethod: payload,
    message: payload?.message ?? state.message
  })
const updateOutsiderPayoutMethodFailure = (state) =>
  state.merge({ updateOutsiderPayoutMethodFetching: false })

const getOutsiderWithdrawalsHistoryRequest = (state) =>
  state.merge({ outsiderWithdrawalsHistoryFetching: true })
const getOutsiderWithdrawalsHistorySuccess = (state, { payload }) =>
  state.merge({
    outsiderWithdrawalsHistoryFetching: false,
    outsiderWithdrawalsHistory: payload
  })
const getOutsiderWithdrawalsHistoryFailure = (state) =>
  state.merge({ outsiderWithdrawalsHistoryFetching: false })

const getReferralBusinessAccountInfoRequest = (state) =>
  state.merge({ referralBusinessAccountFetching: true })
const getReferralBusinessAccountInfoSuccess = (state, { payload }) =>
  state.merge({
    referralBusinessAccountFetching: false,
    referralBusinessAccount: payload
  })
const getReferralBusinessAccountInfoFailure = (state, { errors }) =>
  state.merge({
    referralBusinessAccountFetching: false
  })

const getAffiliateAccountInfoRequest = (state) =>
  state.merge({ affiliateAccountInfoFetching: true })
const getAffiliateAccountInfoSuccess = (state, { payload }) =>
  state.merge({
    affiliateAccountInfoFetching: false,
    affiliateAccountInfo: payload
  })
const getAffiliateAccountInfoFailure = (state) =>
  state.merge({ affiliateAccountInfoFetching: false })

const getCountryCodesRequest = (state) => state.merge({ countryCodesFetching: true })
const getCountryCodesSuccess = (state, { payload }) =>
  state.merge({
    countryCodesFetching: false,
    countryCodes: payload
  })
const getCountryCodesFailure = (state) => state.merge({ countryCodesFetching: false })

const logout = (state) => INITIAL_STATE

const resetMessage = (state) => state.merge({ message: null })

// Bump when the shape of the saved `{ version, adminTableFilters, adminTableColumns,
// adminTableVisibleFilters }` payload changes.
export const REFERRALS_ADMIN_TABLE_PREFERENCES_VERSION = 1

const applyPreferences = (state, { payload }) => {
  const preference = payload?.["referrals-admin-table"]?.data
  if (!preference || preference.version !== REFERRALS_ADMIN_TABLE_PREFERENCES_VERSION) return state
  if (
    !preference.adminTableFilters ||
    !preference.adminTableColumns ||
    !preference.adminTableVisibleFilters
  )
    return state

  const adminTableColumns = preference.adminTableColumns.filter(
    ({ field_id }) => !pinnedCols.includes(field_id)
  )

  return state.merge({
    adminTableFilters: preference.adminTableFilters,
    adminTableColumns,
    adminTableVisibleFilters: preference.adminTableVisibleFilters
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.INVITE_BY_EMAIL_REQUEST]: inviteByEmailRequest,
  [Types.INVITE_BY_EMAIL_SUCCESS]: inviteByEmailSuccess,
  [Types.INVITE_BY_EMAIL_FAILURE]: inviteByEmailFailure,

  [Types.GET_INVITE_LINK_REQUEST]: getInviteLinkRequest,
  [Types.GET_INVITE_LINK_SUCCESS]: getInviteLinkSuccess,
  [Types.GET_INVITE_LINK_FAILURE]: getInviteLinkFailure,

  [Types.GET_YOUR_COMMISSIONS_REQUEST]: getYourCommissionsRequest,
  [Types.GET_YOUR_COMMISSIONS_SUCCESS]: getYourCommissionsSuccess,
  [Types.GET_YOUR_COMMISSIONS_FAILURE]: getYourCommissionsFailure,

  [Types.GET_REFERRALS_TABLE_REQUEST]: getReferralsTableRequest,
  [Types.GET_REFERRALS_TABLE_SUCCESS]: getReferralsTableSuccess,
  [Types.GET_REFERRALS_TABLE_FAILURE]: getReferralsTableFailure,

  [Types.GET_ALERTS_BY_BUSINESS_ACCOUNT_ID_REQUEST]: getAlertsByBusinessAccountIdRequest,
  [Types.GET_ALERTS_BY_BUSINESS_ACCOUNT_ID_SUCCESS]: getAlertsByBusinessAccountIdSuccess,
  [Types.GET_ALERTS_BY_BUSINESS_ACCOUNT_ID_FAILURE]: getAlertsByBusinessAccountIdFailure,

  [Types.GET_FAQ_REQUEST]: getFaqRequest,
  [Types.GET_FAQ_SUCCESS]: getFaqSuccess,
  [Types.GET_FAQ_FAILURE]: getFaqFailure,

  [Types.GET_TOTAL_STATISTICS_REQUEST]: getTotalStatisticsRequest,
  [Types.GET_TOTAL_STATISTICS_SUCCESS]: getTotalStatisticsSuccess,
  [Types.GET_TOTAL_STATISTICS_FAILURE]: getTotalStatisticsFailure,

  [Types.GET_REFERRALS_OVERVIEW_DATA_REQUEST]: getReferralsOverviewDataRequest,
  [Types.GET_REFERRALS_OVERVIEW_DATA_SUCCESS]: getReferralsOverviewDataSuccess,
  [Types.GET_REFERRALS_OVERVIEW_DATA_FAILURE]: getReferralsOverviewDataFailure,

  [Types.GET_REFERRALS_OVERVIEW_MAIN_INFO_REQUEST]: getReferralsOverviewMainInfoRequest,
  [Types.GET_REFERRALS_OVERVIEW_MAIN_INFO_SUCCESS]: getReferralsOverviewMainInfoSuccess,
  [Types.GET_REFERRALS_OVERVIEW_MAIN_INFO_FAILURE]: getReferralsOverviewMainInfoFailure,

  [Types.GET_REFERRAL_BA_OPTIONS_REQUEST]: getReferralBAOptionsRequest,
  [Types.GET_REFERRAL_BA_OPTIONS_SUCCESS]: getReferralBAOptionsSuccess,
  [Types.GET_REFERRAL_BA_OPTIONS_FAILURE]: getReferralBAOptionsFailure,

  [Types.GET_ALERTS_BY_SOURCE_TABLE_REQUEST]: getAlertsBySourceTableRequest,
  [Types.GET_ALERTS_BY_SOURCE_TABLE_SUCCESS]: getAlertsBySourceTableSuccess,
  [Types.GET_ALERTS_BY_SOURCE_TABLE_FAILURE]: getAlertsBySourceTableFailure,

  [Types.GET_ADMIN_STATISTIC_BLOCKS_REQUEST]: getAdminStatisticBlocksRequest,
  [Types.GET_ADMIN_STATISTIC_BLOCKS_SUCCESS]: getAdminStatisticBlocksSuccess,
  [Types.GET_ADMIN_STATISTIC_BLOCKS_FAILURE]: getAdminStatisticBlocksFailure,

  [Types.GET_ADMIN_STATISTIC_BLOCK_CHART_REQUEST]: getAdminStatisticBlockChartRequest,
  [Types.GET_ADMIN_STATISTIC_BLOCK_CHART_SUCCESS]: getAdminStatisticBlockChartSuccess,
  [Types.GET_ADMIN_STATISTIC_BLOCK_CHART_FAILURE]: getAdminStatisticBlockChartFailure,

  [Types.GET_ADMIN_TABLE_REQUEST]: getAdminTableRequest,
  [Types.GET_ADMIN_TABLE_SUCCESS]: getAdminTableSuccess,
  [Types.GET_ADMIN_TABLE_FAILURE]: getAdminTableFailure,

  [Types.EXPORT_ADMIN_TABLE_REQUEST]: exportAdminTableRequest,
  [Types.EXPORT_ADMIN_TABLE_SUCCESS]: exportAdminTableSuccess,
  [Types.EXPORT_ADMIN_TABLE_FAILURE]: exportAdminTableFailure,
  [Types.RESET_ADMIN_TABLE_EXPORT_DATA]: resetAdminTableExportData,

  [Types.GET_ADMIN_TABLE_ALERTS_CHART_REQUEST]: getAdminTableAlertsChartRequest,
  [Types.GET_ADMIN_TABLE_ALERTS_CHART_SUCCESS]: getAdminTableAlertsChartSuccess,
  [Types.GET_ADMIN_TABLE_ALERTS_CHART_FAILURE]: getAdminTableAlertsChartFailure,

  [Types.GET_ADMIN_TABLE_REWARD_CHART_REQUEST]: getAdminTableRewardChartRequest,
  [Types.GET_ADMIN_TABLE_REWARD_CHART_SUCCESS]: getAdminTableRewardChartSuccess,
  [Types.GET_ADMIN_TABLE_REWARD_CHART_FAILURE]: getAdminTableRewardChartFailure,

  [Types.GET_REFERRAL_BUSINESS_ACCOUNT_INFO_REQUEST]: getReferralBusinessAccountInfoRequest,
  [Types.GET_REFERRAL_BUSINESS_ACCOUNT_INFO_SUCCESS]: getReferralBusinessAccountInfoSuccess,
  [Types.GET_REFERRAL_BUSINESS_ACCOUNT_INFO_FAILURE]: getReferralBusinessAccountInfoFailure,

  [Types.SET_EARNINGS_FILTERS]: setEarningsFilters,
  [Types.SET_ADMIN_TABLE_FILTERS]: setAdminTableFilters,
  [Types.SET_ADMIN_TABLE_COLUMNS]: setAdminTableColumns,
  [Types.CLEAR_ADMIN_TABLE_FILTERS]: clearAdminTableFilters,

  [Types.GET_OUTSIDER_BLOCKS_REQUEST]: getOutsiderBlocksRequest,
  [Types.GET_OUTSIDER_BLOCKS_SUCCESS]: getOutsiderBlocksSuccess,
  [Types.GET_OUTSIDER_BLOCKS_FAILURE]: getOutsiderBlocksFailure,

  [Types.OUTSIDER_WITHDRAW_REQUEST]: outsiderWithdrawRequest,
  [Types.OUTSIDER_WITHDRAW_SUCCESS]: outsiderWithdrawSuccess,
  [Types.OUTSIDER_WITHDRAW_FAILURE]: outsiderWithdrawFailure,

  // newly added outsider endpoints
  [Types.GET_OUTSIDER_PAYOUT_METHOD_REQUEST]: getOutsiderPayoutMethodRequest,
  [Types.GET_OUTSIDER_PAYOUT_METHOD_SUCCESS]: getOutsiderPayoutMethodSuccess,
  [Types.GET_OUTSIDER_PAYOUT_METHOD_FAILURE]: getOutsiderPayoutMethodFailure,

  [Types.ADD_OUTSIDER_PAYOUT_METHOD_REQUEST]: addOutsiderPayoutMethodRequest,
  [Types.ADD_OUTSIDER_PAYOUT_METHOD_SUCCESS]: addOutsiderPayoutMethodSuccess,
  [Types.ADD_OUTSIDER_PAYOUT_METHOD_FAILURE]: addOutsiderPayoutMethodFailure,

  [Types.UPDATE_OUTSIDER_PAYOUT_METHOD_REQUEST]: updateOutsiderPayoutMethodRequest,
  [Types.UPDATE_OUTSIDER_PAYOUT_METHOD_SUCCESS]: updateOutsiderPayoutMethodSuccess,
  [Types.UPDATE_OUTSIDER_PAYOUT_METHOD_FAILURE]: updateOutsiderPayoutMethodFailure,

  [Types.GET_OUTSIDER_WITHDRAWALS_HISTORY_REQUEST]: getOutsiderWithdrawalsHistoryRequest,
  [Types.GET_OUTSIDER_WITHDRAWALS_HISTORY_SUCCESS]: getOutsiderWithdrawalsHistorySuccess,
  [Types.GET_OUTSIDER_WITHDRAWALS_HISTORY_FAILURE]: getOutsiderWithdrawalsHistoryFailure,

  [Types.GET_AFFILIATE_ACCOUNT_INFO_REQUEST]: getAffiliateAccountInfoRequest,
  [Types.GET_AFFILIATE_ACCOUNT_INFO_SUCCESS]: getAffiliateAccountInfoSuccess,
  [Types.GET_AFFILIATE_ACCOUNT_INFO_FAILURE]: getAffiliateAccountInfoFailure,

  [Types.GET_COUNTRY_CODES_REQUEST]: getCountryCodesRequest,
  [Types.GET_COUNTRY_CODES_SUCCESS]: getCountryCodesSuccess,
  [Types.GET_COUNTRY_CODES_FAILURE]: getCountryCodesFailure,

  [Types.RESET_MESSAGE]: resetMessage,
  [Types.LOGOUT]: logout,

  [preferencesSuccess.type]: applyPreferences
})
